function sliders(selector, options) {
  let container = document.querySelectorAll(selector);

  if (!container) return;

  container.forEach(function (slider) {
    theme.initWhenVisible({
      element: slider,
      callback: function () {
        if (options instanceof Object) {
          new Flickity(slider, options);
        } else {
          new Flickity(slider);
        }
      },
      threshold: 600,
    });
  });
}

function sliderImageText() {
  let container = document.querySelectorAll(".slider-text-image");
  if (!container) return;

  container.forEach(function (slider) {
    let cells = slider.querySelectorAll(".feature-row").length;
    if (cells < 1) return;

    let settings = {
      wrapAround: true,
      contain: true,
      cellSelector: ".feature-row",
      cellAlign: "left",
      prevNextButtons: true,
      pageDots: false,
    };

    if (theme.config.bpSmall) {
      settings.prevNextButtons = false;
      settings.pageDots = true;
    }

    new Flickity(slider, settings);
  });
}

function appendMobileMenu() {
  let burger = document.querySelector(".js-drawer-open-nav");

  if (!burger) return;

  let appendTo = document.querySelector(".header-item--navigation");
  if (theme.config.bpSmall) appendTo.appendChild(burger);
}

function storyLogoSlider() {
  let container = document.querySelectorAll(".story__logos");

  if (!container) return;

  container.forEach(function (logo) {
    let logoSliderContainer = logo.querySelector(".logo-bar");
    let sliderRequire = logoSliderContainer.clientWidth < 1420;

    if (sliderRequire && !theme.config.bpSmall) {
      logoSliderContainer.classList.add("slider--enable");

      new Flickity(logoSliderContainer, {
        wrapAround: true,
        contain: true,
        cellSelector: ".logo-bar__item",
        cellAlign: "left",
        prevNextButtons: true,
        pageDots: false,
      });
    }
  });
}

function pairItWithSlider() {
  let container = document.getElementById("pair_it_with");

  if (!container) return;

  let slider = container.querySelector(".grid");

  let settings = {
    contain: true,
    cellSelector: ".grid__item",
    cellAlign: "left",
    prevNextButtons: false,
    freeScroll: true,
    pageDots: false,
  }

  let items = container.querySelectorAll(".grid__item").length;

  new Flickity(slider, settings);
}

function logoListSlider() {
  let logoContainer = document.querySelector(
    ".full_width_logo_wrapper .full_width_logo_list .grid"
  );

  if (!logoContainer) return;

  theme.initWhenVisible({
    element: logoContainer,
    callback: function () {
      setTimeout(function () {
        new Flickity(logoContainer, {
          contain: true,
          wrapAround: true,
          cellSelector: ".grid__item",
          cellAlign: "left",
          prevNextButtons: false,
          freeScroll: false,
          pageDots: true,
          autoPlay: 2000,
        });
      }, 500);
    },
  });
}

function teamMemberSlider() {
  let container = document.querySelector(".team-members-slider");

  if (!container) return;

  let slider = container.querySelector(".grid");

  let settings = {
    contain: true,
    cellSelector: ".grid__item",
    cellAlign: "left",
    prevNextButtons: true,
    pageDots: false,
    freeScrollFriction: 0.03,
  };

  if (theme.config.bpSmall) {
    settings.prevNextButtons = false;
    settings.pageDots = true;
  }

  theme.initWhenVisible({
    element: slider,
    callback: function () {
      setTimeout(function () {
        new Flickity(slider, settings);
      }, 500);
    },
  });
}

function singleLogoSlider() {
  let container = document.querySelectorAll(".single-image-slider .grid");

  if (!container) return;
  if (theme.config.bpSmall) {
    container.forEach((slider) => {
      theme.initWhenVisible({
        element: slider,
        callback: function () {
          setTimeout(function () {
            new Flickity(slider, {
              contain: true,
              cellSelector: ".grid__item",
              cellAlign: "left",
              prevNextButtons: false,
              pageDots: true,
              freeScrollFriction: 0.03,
            });
          }, 500);
        },
      });
    });
  }
}

function wrapElements(selector, className) {
  const elementsToWrap = document.querySelectorAll(selector);

  if (!elementsToWrap.length) {
    console.error(
      `No elements matching the selector '${selector}' were found.`
    );
    return;
  }

  const wrapper = document.createElement("div");
  wrapper.classList.add(className);

  const firstElement = elementsToWrap[0];
  const parent = firstElement.parentNode;

  for (let i = 0; i < elementsToWrap.length; i++) {
    const element = elementsToWrap[i];
    if (element.parentNode === parent) {
      parent.insertBefore(wrapper, element);
      wrapper.appendChild(element);
    } else {
      console.error(`All elements must have the same parent.`);
      return;
    }
  }

  parent.appendChild(wrapper);
}

function wrapItemsInDivs(selector) {
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    const items = element.querySelectorAll("div:not(.h5)");
    let classes = element.querySelector(".h5 a").innerHTML.toLowerCase();
    console.log(classes);
    const div = document.createElement("div");
    div.classList.add(
      "grid__item",
      "medium-up--one-fifth",
      "grandparent-category",
      classes
    );
    items.forEach((item) => {
      div.appendChild(item);
    });

    element.appendChild(div);
  });
}

function findParent(selector, cl) {
  var childElement = document.querySelector(selector);
  var parentElement = childElement.parentNode;

  while (parentElement && !parentElement.classList.contains(cl)) {
    parentElement = parentElement.parentNode;
  }
}

// function platedProjectMegaMenu() {
//   wrapItemsInDivs(".plated-project-megamenu .megamenu .grid .grid__item");

//   let GrandChilds = document.querySelectorAll(
//     ".plated-project-megamenu .megamenu .grandparent-category"
//   );

//   // findParent('.megamenu .page-width')
//   GrandChilds.forEach((child) => {
//     child.parentElement.parentElement.append(child);
//   });
// }

function platedProjectMegaMenu() {
  let megaMenu = document.querySelectorAll(".pated-project-megamenu");

  if (!megaMenu) return;

  megaMenu.forEach((menu) => {
    let items = menu.querySelectorAll(".h5");
    let menuItems = menu.querySelectorAll(".menu-items .menu-item");
    items.forEach((item) => {
      item.addEventListener("mouseover", function () {
        item.classList.remove("currently_active");
        items.forEach((i) => i.classList.remove("currently_active"));
        let menu_id = this.dataset.menushow;
        menuItems.forEach((item) => item.classList.remove("is_active"));
        let showMenu = this.closest(".pated-project-megamenu").querySelector(
          "#" + menu_id
        );
        showMenu.classList.add("is_active");

        this.classList.add("currently_active");
      });
    });
  });
}

function sliderInit() {
  let settings = {
    wrapAround: true,
    contain: true,
    cellSelector: ".grid__item",
    cellAlign: "left",
    prevNextButtons: true,
    pageDots: false,
  };
  if (theme.config.bpSmall) {
    settings.prevNextButtons = false;
    settings.pageDots = true;
  }
  sliders(".slider .grid", settings);
}

function sliderInitMobile() {
  let settings = {
    wrapAround: true,
    contain: true,
    cellSelector: ".logo-bar__item",
    cellAlign: "left",
    prevNextButtons: true,
    pageDots: false,
  };
  setTimeout(() => {
    sliders(".slider-m .logo-bar", settings);
  });
}

function giftWrap(evt) {
  theme.cart.getCart().then(cart => {
    let cart_items = cart.items;
    
    const onlyWrapinCart = cart_items.every(v => v.id === 39628064915507);
    
    if(onlyWrapinCart && cart_items.length) {
      cart_items.forEach(item => {
        theme.cart.changeItem(item.key,0);
      });
      window.location.reload();
    }
  });
}

function copyDiscountCodes() {
  let discountContainer = document.getElementById('present__offers')

  if(!discountContainer) return;

  let codes = discountContainer.querySelectorAll('.discount_code-copyBtn');

  codes.forEach(code => {
    code.addEventListener('click', function () {
      let codeWrapper = this.closest('.offer-item');
      let codeInput = codeWrapper.querySelector('.discount_code-copy');
      copyInputValue(codeInput);
      this.innerText = 'Copied'
    });
  });
}

document.addEventListener('cart:updated', function() {
  giftWrap(); 
});

function copyInputValue(input) {
  const range = document.createRange();
  range.selectNode(input);

  const selection = document.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand('copy');
  selection.removeAllRanges();
}



document.addEventListener("DOMContentLoaded", function () {
  if (!theme.config.bpSmall) {
    platedProjectMegaMenu();
  }

  sliderImageText();

  appendMobileMenu();

  //storyLogoSlider();

  pairItWithSlider();

  if (theme.config.bpSmall) {
    logoListSlider();
    sliderInitMobile();
  }
  singleLogoSlider();
  teamMemberSlider();
  sliderInit();
  if (
    document.querySelector("[featured_colletion_slider] .grid") &&
    !theme.config.bpSmall
  ) {
    new Flickity(document.querySelector("[featured_colletion_slider] .grid"), {
      wrapAround: true,
      contains: true,
      freeScroll: true,
      pageDots: false,
      cellAlign: "left",
    });
  }
   giftWrap(); 
   copyDiscountCodes();
  if (theme.config.bpSmall) {
new Flickity(document.querySelector('.slider-m-page-dots .logo-bar'),{
    wrapAround: true,
    contains: true,
    pageDots: true,
    prevNextButtons: false,
  adaptiveHeight: true

});
}
});

